<template>
  <span>
    <el-tooltip effect="dark" :content="tooltipContent" :disabled="!isShowTooltip" placement="top" popper-class="custom-tooltip">
      <template v-if="itemTypeHere==='xy_custom'">
        <slot :name="x1.slotName" :row="row" />
      </template>

      <template v-else-if="itemTypeHere==='xy_phone'">
        <el-input
          size="mini" v-model="row[(x1.phoneShow&&x1.phoneShow(row)?'':'_')+x1.key]" clearable
          :disabled="itemDisabled"
          :placeholder="x1.placeholder"
          :class="x1.class||''" :style="itemStyle"
          @change="e=>itemChange(x1.key,e)" />
      </template>

      <template v-else-if="itemTypeHere==='xy_input'">
        <el-input
          size="mini" v-model="row[x1.key]" clearable
          :disabled="itemDisabled"
          :placeholder="x1.placeholder"
          :class="x1.class||''" :style="itemStyle"
          @change="e=>itemChange(x1.key,e)" />
      </template>

      <template v-else-if="itemTypeHere==='xy_textarea'">
        <el-input
          size="mini" v-model="row[x1.key]" clearable
          :disabled="itemDisabled"
          :placeholder="x1.placeholder"
          :class="x1.class||''" :style="itemStyle"
          type="textarea" :rows="4"
          @change="e=>itemChange(x1.key,e)" />
      </template>

      <template v-else-if="itemTypeHere==='xy_rich'">
        <EditorBar v-model="row[x1.key]" />
      </template>

      <template v-else-if="itemTypeHere==='xy_number'">
        <el-input-number
          size="mini" v-model="row[x1.key]" clearable
          :disabled="itemDisabled"
          :placeholder="x1.placeholder"
          :class="x1.class||''" :style="itemStyle"
          @change="e=>itemChange(x1.key,e)" />
      </template>

      <template v-else-if="itemTypeHere==='xy_switch'">
        <el-switch
          size="mini" v-model="row[x1.key]"
          :disabled="itemDisabled"
          :class="x1.class||''"
          :inactive-text="x1.left" :active-text="x1.right"
          :inactive-value="x1.left" :active-value="x1.right"
          @change="e=>itemChange(x1.key,e)" />
      </template>

      <template v-else-if="itemTypeHere==='xy_radio'">
        <el-radio-group
          size="mini" v-model="row[x1.key]"
          :disabled="itemDisabled"
          :class="x1.class||''"
          @change="e=>itemChange(x1.key,e)">
          <el-radio v-for="(x2, i2) in itemOptions" :key="i2" :label="x2.label?x2.value:x2">{{x2.label||x2}}</el-radio>
        </el-radio-group>
      </template>

      <template v-else-if="itemTypeHere==='xy_select'">
        <el-select
          size="mini" v-model="row[x1.key]" clearable
          :disabled="itemDisabled"
          :placeholder="x1.placeholder"
          :class="x1.class||''" :style="itemStyle"
          :multiple="x1.multiple" filterable
          :remote="!!x1.remoteMethod" :remote-method="x1.remoteMethod?x1.remoteMethod:()=>{}"
          @change="e=>itemChange(x1.key,e)">
          <el-option v-for="(x2, i2) in itemOptions" :key="i2" :label="x2.label||x2" :value="x2.label?x2.value:x2"></el-option>
        </el-select>
      </template>

      <template v-else-if="itemTypeHere==='xy_date'">
        <el-date-picker
          size="mini" v-model="row[x1.key]"
          :disabled="itemDisabled"
          :placeholder="x1.placeholder||'选择时间'"
          :class="x1.class||''" :style="itemStyle"
          type="date" :default-time="x1.defaultTime||'00:00:00'"
          format="yyyy-MM-dd" value-format="timestamp"
          @change="e=>itemChange(x1.key,e)"></el-date-picker>
      </template>

      <template v-else-if="itemTypeHere==='xy_daterange'">
        <el-date-picker
          size="mini" v-model="row[x1.key]"
          :disabled="itemDisabled"
          :placeholder="x1.placeholder||'选择时间'"
          :class="x1.class||''" :style="itemStyle"
          type="daterange" :default-time="['00:00:00', '23:59:59']"
          format="yyyy-MM-dd" value-format="timestamp"
          start-placeholder="开始日期" end-placeholder="结束日期"
          @change="e=>itemChange(x1.key,e)"></el-date-picker>
      </template>

      <template v-else-if="itemTypeHere==='xy_datetime'">
        <el-date-picker
          size="mini" v-model="row[x1.key]"
          :disabled="itemDisabled"
          :placeholder="x1.placeholder||'选择时间'"
          :class="x1.class||''" :style="itemStyle"
          type="datetime" :default-time="x1.defaultTime||'00:00:00'"
          format="yyyy-MM-dd HH:mm:ss" value-format="timestamp"
          @change="e=>itemChange(x1.key,e)"></el-date-picker>
      </template>

      <template v-else-if="itemTypeHere==='xy_image'">
        <template v-if="!x1.limitNum||x1.limitNum===1">
          <el-image
            :src="row[x1.key]|toimg" fit="contain"
            :class="x1.class||''" :style="x1.style||'width:100px;height:100px;'"
            :preview-src-list="[row[x1.key]]|toimgs" />
        </template>
        <template v-else>
          <el-image
            v-for="(x2,i2) in row[x1.key]" :key="i2"
            :src="x2|toimg" fit="contain"
            :class="x1.class||''" :style="x1.style||'width:100px;height:100px;'"
            :preview-src-list="row[x1.key]|toimgs" />
        </template>
      </template>

      <template v-else-if="itemTypeHere==='xy_video'">
        <video v-if="eData[x1.key]" controls="controls" :src="row[x1.key]|toimg" class="video">您的浏览器不支持视频播放</video>
      </template>

      <template v-else-if="itemTypeHere==='xy_upload'">
        <template v-if="x1.type==='image'">
          <p style="height:40.upload-image px;line-height:32px;font-size:12px;">
            建议尺寸{{x1.size?x1.size:'750px*750px'}}，建议格式jpg，限制{{x1.fileList.length+'/'+(x1.limitNum||1)}}张
          </p>
          <el-upload
            :action="action" :accept="x1.accept||'.jpg,.jpeg,.png'"
            :file-list="x1.fileList" :limit="(x1.limitNum||1)" list-type="picture-card" multiple
            class="upload-image" :class="{'disabled':x1.fileList.length>=(x1.limitNum||1)}"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUploadImage">
            <!-- accept=".jpg,.jpeg,.png,.bmp,.gif" -->
            <i class="el-icon-plus"></i>
          </el-upload>
        </template>
        <template v-else-if="x1.type==='video'">
          <video v-if="x1.fileList.length" controls :src="_img_handler(x1.fileList[0].id)" class="video">您的浏览器不支持视频播放</video>
          <el-upload
            :action="action" :accept="x1.accept||'.mp4'"
            :file-list="x1.fileList" :limit="(x1.limitNum||1)"
            class="upload-video" :class="{'disabled':x1.fileList.length>=(x1.limitNum||1)}"
            :data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
            :on-progress="handleProcess"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :before-upload="(file)=>beforeUploadVideo(file,(x1.limitNum||1))">
            <!-- accept=".mp4,.mkv,.rm,.rmvb,.mpeg1-4,.mov,.mtv,.dat,.wmv,.avi,.3gp,.amv,.dmv,.flv" -->
            <i v-if="!x1.fileList.length" class="el-icon-plus upload-video-icon"></i>
          </el-upload>
        </template>
      </template>

      <template v-else>
        <span v-if="x1.eType==='xy_date'">{{ row[x1.key.replace('Time', 'Date')] || $t.toYMD(row[x1.key]) }}</span>
        <span v-else v-html="row[x1.key]"></span>
      </template>
    </el-tooltip>
    
    <!-- 图片预览 -->
    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog> -->
  </span>
</template>

<script>
// 导入安装好的wangeditor
import E from 'wangeditor'
// 导入封装好的公共组件wangEditor
import EditorBar from '@/components/wangEditor'
import AreaPicker from '@/components/AreaPicker'
import TOOL from '@/library/TOOL'

export default {
  components: { EditorBar, AreaPicker },
  props: {
    row: { type: Object, default: () => {} },
    x1: { type: Object, default: () => {} },
    typeKey: { type: String, default: 't' },
  },
  filters: {
    toHidePhone: TOOL.toHidePhone,
  },
  data() {
    return {
      // dialogImageUrl: '', // 预览图片路径
      // dialogVisible: false, // 预览对话框是否可见
    }
  },
  computed: {
    itemTypeHere() {
      const { type, cType, eType } = this.x1
      if (this.typeKey === 'c') {
        return cType || eType || type || ''
      }
      return this.x1[this.typeKey + 'Type'] || type || ''
    },
    itemDisabled() {
      const { cDisabled, eDisabled, disabled} = this.x1
      const FLAG0 = this.typeKey === 'f'
      const FLAG1 = this.typeKey === 'c' && (cDisabled === undefined ? eDisabled : cDisabled)
      const FLAG2 = this.typeKey === 'e' && eDisabled
      const FLAG3 = this.typeKey === 'v'

      const FLAG = FLAG1 || FLAG2 || FLAG3 || disabled
      switch (this.itemTypeHere) {
        case 'xy_phone':
          return FLAG0 || FLAG
        default:
          return FLAG
      }
    },
    itemOptions() {
      return this.x1[this.typeKey + 'Options'] || this.x1.options
    },
    itemStyle() {
      if (this.x1.style) return this.x1.style
      switch (this.typeKey) {
        case 't':
          return `width:130px;`
        case 'f':
          return `width:100%;`
        case 'v':
        case 'c':
        case 'e':
          return `width:418px;`
      }
    },
    isShowTooltip() {
      const VAL = this.row[this.x1.key]
      const TYPE = this.itemTypeHere
      if (['xy_select'].includes(TYPE) && this.x1.multiple && VAL) {
        return VAL.length > 0
      } else if (['xy_date', 'xy_datetime'].includes(TYPE)) {
        return VAL && VAL > 0
      } else if (['xy_radio'].includes(TYPE)) {
        return false
      } else {
        return VAL !== undefined && VAL !== null && VAL !== ''
      }
    },
    tooltipContent() {
      const VAL = this.row[this.x1.key]
      const TYPE = this.itemTypeHere
      if (['xy_select'].includes(TYPE)) {
        const OPS = this.itemOptions
        if (OPS && OPS[0] && OPS[0].label) {
          if (Array.isArray(VAL)) {
            const LIST = VAL.map(e1 => OPS.find(e2 => e2.value === e1).label)
            return LIST.join('，')
          } else {
            const ITEM = OPS.find(e2 => e2.value === VAL)
            return ITEM ? ITEM.label : String(VAL)
          }
        } else {
          return String(VAL)
        }
      } else if (['xy_date', 'xy_datetime'].includes(TYPE)) {
        if (VAL && VAL > 0) {
          return this.$t.toYMD(VAL)
        } else {
          return ''
        }
      } else if (['xy_daterange'].includes(TYPE)) {
        if (VAL && VAL.length > 0) {
          return this.$t.toYMD(VAL[0]) + '~' + this.$t.toYMD(VAL[1])
        } else {
          return ''
        }
      } else if (['xy_phone'].includes(TYPE)) {
        if (this.x1.phoneShow && this.x1.phoneShow(this.row)) {
          return VAL
        } else {
          return this.row['_' + this.x1.key]
        }
      } else if (Array.isArray(VAL)) {
        return VAL.join('，')
      } else {
        return String(VAL)
      }
    },
  },
  methods: {
    // #region 通用
    itemChange(key, e) {
      // console.log(`%ckey, e:`, 'color: #f00;', key, e)
      const cb = this.x1.callback
      if (cb && typeof cb === 'function') {
        cb(key, e, this.row)
      }
    },
    // #endregion

    // #region 图片上传
    // 成功
    handleSuccess(rep, file, fileList) {
      file.id = JSON.parse(file.response.data).fileId
      this.x1.fileList = fileList
    },
    // 失败
    handleError(err, file, fileList) {
      this.x1.fileList = fileList
    },
    // 移除
    handleRemove(file, fileList) {
      this.x1.fileList = fileList
    },

    // 文件超出个数限制时的钩子
    handleExceed(file, fileList) {
      this.$message.warning('超出上传数量限制！')
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url
      // this.dialogVisible = true
    },
    beforeUploadImage(file) {
      const isJPG = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type)
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isJPG) { this.$message.error('请上传jpg或png图片！') }
      if (!isLt20M) { this.$message.error('图片大小不能超过2MB！') }
      return isJPG && isLt20M
    },
    beforeUploadVideo(file, limitNum = 1) {
      const isMP4 = ['video/mp4'].includes(file.type)
      const isLt500M = file.size / 1024 / 1024 < 500
      const isLtCount = this.x1.fileList.length <= limitNum
      if (!isMP4) { this.$message.error('目前仅支持mp4格式上传！') }
      if (!isLt500M) { this.$message.error('视频大小不能超过500MB！') }
      if (!isLtCount) { this.$message.error('超出上传数量限制！') }
      return isMP4 && isLt500M && isLtCount
    },
    handleProcess(event, file, fileList, index) {},
    // #endregion
  },
}
</script>

<style lang='scss' scoped>
.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}


/deep/ .upload-image .el-upload--picture-card,
/deep/ .upload-image .el-upload-list__item {width:90px;height:90px;position:relative;transition:none !important;} // 图片盒子大小
/deep/ .upload-image .el-icon-plus {width:28px;height:28px; position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;} // 图片加号位置
/deep/ .disabled .el-upload--picture-card {display:none} // 图片超出数量限制 隐藏上传按钮

// /deep/ .el-form-item__label,
// /deep/ .el-cascader__search-input,
// /deep/ .el-radio__label {font-size: 12px;}

// /deep/.el-select__tags{overflow: auto;}


.video{width: 400px;max-height: 240px;}


// 视频
/deep/.upload-video .el-upload--text {border: 1px dashed #c0ccda;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
/deep/.upload-video .el-upload--text:hover {border-color: #409EFF;color: #409EFF;}
.upload-video-icon {
  width:90px;height:90px;line-height:90px;text-align: center;
  background-color: #fbfdff;font-size: 28px;color: #8c939d;
}
/deep/.el-upload-list--text{width: 400px;}
.video{width: 400px;max-height: 240px;}
/deep/ .disabled .el-upload--text{display: none;}

// 禁用
/deep/ .el-input.is-disabled .el-input__inner{
  background-color: #fff;
  color: #606266;
  border-color: #DCDFE6;
}
</style>